<footer>
  <div>
    <a routerLink="/legal" translate>Impressum</a>
  </div>
</footer>
